import React from 'react';
import { CustomerReviews } from './CustomerReviews';
export const CustomerExperience = () => {
  return <section id="reviews" className="py-16 bg-gray-50 w-full" data-id="element-40">
      <div className="container mx-auto px-4" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-43">
            Experiences of Our Participants
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-44">
            Read what our hikers have to say about their adventures with us
          </p>
        </div>
        <CustomerReviews data-id="element-45" />
      </div>
    </section>;
};